import { actions } from '@luxuryescapes/contract-svc-travel-compliance';

import { request } from './common';

function basePath() {
  return window.configs.API_HOST + '/api/';
}

function postRequest(path: string, data: unknown) {
  return request(path, {
    method: 'POST',
    body: JSON.stringify(data),
    headers: { 'Content-Type': 'application/json' },
  });
}

export type AtolOfflineFlightsPayload = actions['previewOfflineCertificate']['parameters']['body']['payload'];

export type AtolPreviewResponse =
  actions['previewOfflineCertificate']['responses']['200']['content']['application/json'];

export type AtolSendResponse = actions['sendOfflineCertificate']['responses']['201']['content']['application/json'];

export async function getAtolReportByUrl(
  reportName: string,
  data: { year: string; month: string },
): Promise<{ result: Array<Record<string, unknown>> }> {
  return postRequest(basePath() + `travel-compliance/v1/atol/reports/${reportName}`, data);
}

/**
 * Preview an ATOL certificate for offline flights.
 * Returns the rendered certificate HTML and metadata without persisting.
 */
export async function previewAtolOfflineFlightsCertificate(
  payload: AtolOfflineFlightsPayload,
): Promise<AtolPreviewResponse> {
  return postRequest(basePath() + 'travel-compliance/v1/atol/offline-flights/preview', payload);
}

/**
 * Send an ATOL certificate for offline flights.
 * Persists the certificate and sends it to the customer via email.
 */
export async function sendAtolOfflineFlightsCertificate(payload: AtolOfflineFlightsPayload): Promise<AtolSendResponse> {
  return postRequest(basePath() + 'travel-compliance/v1/atol/offline-flights/send', payload);
}
